"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimObjectValues = void 0;
/*
  {
    email: '    test@test.com     '
    phoneNumber: '  111 '
  }

  ->

  {
    email: 'test@test.com',
    phoneNumber: '111'
  }
*/
// it has many any assignments
/* eslint-disable */
function trimObjectValues(values) {
    if (!values)
        return values;
    var trimmedValues = {};
    Object.entries(values).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'string') {
            trimmedValues[key] = value.trim();
        }
        else if ((value === null || value === void 0 ? void 0 : value.constructor) === Object) { // only trim plain object
            trimmedValues[key] = trimObjectValues(value);
        }
        else {
            trimmedValues[key] = value;
        }
    });
    return trimmedValues;
}
exports.trimObjectValues = trimObjectValues;
/* eslint-enable */
